import { makeStyles, Theme } from "@material-ui/core";
import React from "react";

import { FONT_MED } from "../../styles/fonts";

interface SectionCardLinkProps {
  icon?: React.ReactNode;
  label: React.ReactNode;
  onClick: () => void;
  className?: string;
  dataTestId?: string;
}

export default function SectionCardLink({
  icon,
  label,
  onClick,
  className = "",
  dataTestId,
}: SectionCardLinkProps) {
  const classes = useStyles();
  return (
    <button
      type="button"
      className={`${classes.root} ${className}`}
      data-testid={dataTestId}
      onClick={onClick}
    >
      {icon && <span className={classes.icon}>{icon}</span>}
      <span className={classes.label}>{label}</span>
    </button>
  );
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: "inline-flex",
    alignItems: "center",
    gap: 4,
    color: theme.palette.primary.main,
    cursor: "pointer",
    background: "none",
    border: "none",
    padding: 0,
    font: "inherit",
    textAlign: "inherit",
  },
  icon: {
    display: "inline-flex",
    fontSize: 16,
    "& > *": {
      fontSize: "inherit",
    },
  },
  label: {
    ...FONT_MED,
    fontSize: 14,
    lineHeight: "18px",
  },
}));
